import { render, staticRenderFns } from "./price-info.vue?vue&type=template&id=d32600d8&"
import script from "./price-info.vue?vue&type=script&lang=js&"
export * from "./price-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports